import React, {Component} from 'react';
import {Spinner} from "./Spinner";

export class SpinnerSecondaryButton extends Component {
    render() {
        return (
            <div className="loading-save-button-secondary">
                <Spinner specialClass="lds-dual-ring-secondary-color" color="negative very-small"/>
            </div>
        )
    }
}
